<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['close']);
const store = useStore();
const { t } = useI18n();

const name = ref('');
const category = ref('Outros');
const color = ref('#4A6CF7');

const uiFlags = useMapGetter('contactReasons/getUIFlags');

const categories = ['Técnico', 'Financeiro', 'Comercial', 'Outros'];

const isValid = computed(() => name.value.trim().length >= 2);

const onClose = () => emit('close');

const addReason = async () => {
  if (!isValid.value) return;
  try {
    await store.dispatch('contactReasons/create', {
      contact_reason: {
        name: name.value.trim(),
        category: category.value,
        color: color.value,
      },
    });
    useAlert(t('CONTACT_REASONS_MGMT.ADD.API.SUCCESS_MESSAGE'));
    onClose();
  } catch (error) {
    const errorMessage =
      error.message || t('CONTACT_REASONS_MGMT.ADD.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header :header-title="$t('CONTACT_REASONS_MGMT.ADD.TITLE')" />
    <form class="flex flex-wrap mx-0" @submit.prevent="addReason">
      <woot-input
        v-model="name"
        class="w-full"
        :label="$t('CONTACT_REASONS_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('CONTACT_REASONS_MGMT.FORM.NAME.PLACEHOLDER')"
      />

      <div class="w-full mb-4">
        <label class="block mb-1 text-sm font-medium text-n-slate-12">
          {{ $t('CONTACT_REASONS_MGMT.FORM.CATEGORY.LABEL') }}
        </label>
        <select
          v-model="category"
          class="w-full px-3 py-2 border rounded-lg border-n-weak bg-n-solid-2 text-n-slate-12"
        >
          <option v-for="cat in categories" :key="cat" :value="cat">
            {{ cat }}
          </option>
        </select>
      </div>

      <div class="w-full mb-4">
        <label class="block mb-1 text-sm font-medium text-n-slate-12">
          {{ $t('CONTACT_REASONS_MGMT.FORM.COLOR.LABEL') }}
        </label>
        <woot-color-picker v-model="color" />
      </div>

      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('CONTACT_REASONS_MGMT.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :label="$t('CONTACT_REASONS_MGMT.FORM.CREATE')"
          :disabled="!isValid || uiFlags.isCreating"
          :is-loading="uiFlags.isCreating"
        />
      </div>
    </form>
  </div>
</template>
